'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typeof alert !== 'undefined' ? alert : function () {};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/dom/showError.js
// module id = 85
// module chunks = 0